<template>
  <VModalWithAside
    v-if="currentState.isResolved"
    ref="modal"
    disable-backdrop-click
    :on-modal-hide="handleModalHidden"
  >
    <template #aside>
      <portal-target name="modal-aside" slim />
    </template>
    <template #default>
      <OrderItemDialog
        :account-id="accountId"
        :client-id="clientId"
        :order-item-id="orderItemId"
        @close="$refs.modal.close()"
      />
    </template>
  </VModalWithAside>
</template>

<script>
import VModalWithAside from '@/components/Common/VModalWithAside.vue';
import OrderItemDialog from './OrderItemDialog.vue';

const STATE_IDLE = 'STATE_IDLE';
const STATE_PENDING = 'STATE_PENDING';
const STATE_RESOLVED = 'STATE_RESOLVED';
const STATE_REJECTED = 'STATE_REJECTED';

export default {
  name: 'OrderItemModalWithAside',

  components: {
    VModalWithAside,
    OrderItemDialog,
  },

  props: {
    accountId: {
      type: String,
      required: true,
    },
    clientId: {
      type: String,
      required: true,
    },
    orderItemId: {
      type: String,
      required: true,
    },
  },

  data() {
    return {
      state: STATE_IDLE,
    };
  },

  computed: {
    orderItem() {
      return this.$store.state.entities.orderItems.byId[this.orderItemId] || null;
    },
    currentState() {
      return {
        isIdle: this.state === STATE_IDLE,
        isPending: this.state === STATE_PENDING,
        isResolved: this.state === STATE_RESOLVED,
        isRejected: this.state === STATE_REJECTED,
      };
    },
  },

  created() {
    this.init();
  },

  methods: {
    async init() {
      if (this.currentState.isPending) {
        return;
      }

      this.state = STATE_PENDING;

      try {
        await this.$store.dispatch({
          type: 'ui/orderItems/read',
          orderItemUuid: this.orderItemId,
          params: {
            include: 'links,notes,media,orderable',
          },
        });
        this.state = STATE_RESOLVED;
      } catch (error) {
        this.state = STATE_REJECTED;
      }
    },
    handleModalHidden() {
      this.$emit('closed');
    },
  },
};
</script>
